<template>
    <Transition name="auth-status-fade">
        <div v-if="show" class="auth-status-overlay" role="status" aria-live="polite">
            <div :class="['auth-status-panel', { 'auth-status-panel--busy': busy }]">
                <img v-if="busy" :src="loaderAnimation" class="auth-status-panel__spinner" alt="" aria-hidden="true" />
                <h2 v-if="!busy && title">{{ title }}</h2>
                <p>{{ message }}</p>
                <div v-if="hasActions" class="auth-status-panel__actions">
                    <Cta v-if="secondaryLabel" dark-scheme type="secondary" @click="$emit('secondary')">
                        {{ secondaryLabel }}
                    </Cta>
                    <Cta v-if="primaryLabel" dark-scheme type="primary" @click="$emit('primary')">
                        {{ primaryLabel }}
                    </Cta>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
    import Cta from "../../common/components/CtaButton.vue";
    import loaderAnimation from "@/images/loadinganim.gif";

    export default {
        name: 'auth-status-modal',
        components: { Cta },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: '',
            },
            message: {
                type: String,
                default: '',
            },
            primaryLabel: {
                type: String,
                default: null,
            },
            secondaryLabel: {
                type: String,
                default: null,
            },
            busy: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                loaderAnimation,
            }
        },
        computed: {
            hasActions() {
                return Boolean(this.primaryLabel || this.secondaryLabel);
            },
        },
        emits: ['primary', 'secondary'],
    }
</script>

<style lang="scss" scoped>
    .auth-status-overlay {
        align-items: center;
        background: rgba(15, 15, 15, 0.75);
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        padding: 24px;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 9999;
    }

    .auth-status-panel {
        align-items: center;
        color: var(--asphalt10);
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-width: 420px;
        text-align: center;
        width: min(100%, 420px);

        &--busy {
            max-width: 360px;
        }

        h2,
        p {
            margin: 0;
        }

        h2 {
            color: var(--asphalt10);
            font: var(--editor-ui-h3);
        }

        p {
            color: rgba(255, 255, 255, 0.82);
            font: var(--editor-ui-b2-regular);
            line-height: 1.45;
        }
    }

    .auth-status-panel__spinner {
        height: 80px;
        width: 80px;
    }

    .auth-status-panel__actions {
        display: flex;
        gap: 12px;
        justify-content: center;
        margin-top: 8px;
    }

    .auth-status-fade-enter-active,
    .auth-status-fade-leave-active {
        transition: opacity 180ms ease;
    }

    .auth-status-fade-enter-from,
    .auth-status-fade-leave-to {
        opacity: 0;
    }
</style>
